import sign from "jwt-encode";

import { JWTPayload } from "./types";

export const generateJWT = (payload: JWTPayload, secretKey: string): string => {
  return sign(payload, secretKey);
};
